import type { CinematicOverrides, CinematicWaypoint } from '../../../renderer/src/cinematic-sequence';
import type { CinematicSettings } from '../domain/cinematic-plan';

/** Inspect one authored value while other properties follow their live tracks. */
export function inspectedSceneSettings(current: CinematicSettings, key: CinematicWaypoint, property: keyof CinematicOverrides): CinematicSettings {
  const value = key.overrides[property];
  if (value === undefined) return current;
  return { ...current, [property]: value, ...(property === 'presentationAppearance'
    ? { presentationAppearance: { ...current.presentationAppearance, ...key.overrides.presentationAppearance } } : {}) };
}
